import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { clearReturnTo, peekReturnTo, safePath } from "../Helpers/webSession";

function PublicRoutes({ children }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    // After signing in, open the page the person was on when the sign-in ended (or was asked for), else the dashboard.
    // Worked out when the sign-in happens (not when this page opened) and kept, because it is cleared right after.
    const targetRef = useRef(null);
    if (isAuthenticated && !targetRef.current) {
        targetRef.current = peekReturnTo() || safePath(location.state?.from) || "/dashboard";
    }

    useEffect(() => {
        if (isAuthenticated) clearReturnTo();
    }, [isAuthenticated]);

    if (isAuthenticated) {
        return <Navigate to={targetRef.current} replace />;
    }

    return (
        <React.Fragment>
            {children}
            <Outlet />
        </React.Fragment>
    );
}

export default PublicRoutes;
